import { cn } from '@/utils';

const SelectWeekday = ({ selectedDay, highlightedDays, onClickDay }) => {
  const days = [
    { label: 'S', value: 0 }, // Sunday
    { label: 'M', value: 1 }, // Monday
    { label: 'T', value: 2 }, // Tuesday
    { label: 'W', value: 3 }, // Wednesday
    { label: 'T', value: 4 }, // Thursday
    { label: 'F', value: 5 }, // Friday
    { label: 'S', value: 6 } // Saturday
  ];

  return (
    <div className="flex justify-between pb-6">
      {days.map((day) => (
        <div
          onClick={() => onClickDay(day.value)}
          key={day.value}
          className={cn(
            'w-10 h-10 rounded-full border border-muted flex items-center justify-center relative',
            highlightedDays.includes(day.value) && 'bg-primary',
            selectedDay === day.value &&
              'border-secondary border-2 transform scale-120 transition-transform duration-200 ease-in-out'
          )}
        >
          <span className="text-[14px] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            {day.label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default SelectWeekday;
